<template>
    <div>
        <virtual-steper :steps="steps" v-model="step" class="mb-1 px-1" variant="danger"></virtual-steper>
        <div class="px-1 pb-1">
            <div class="row">
                <div :class="approveStatuses.length > 0 ? 'col-md-10' : 'col-md-12'">
                    <div v-if="canExit" class="bg-light-danger bg-container rounded-lg p-50">
                        <div class="border-danger rounded bg-surface">
                            <employee-job-exit-request      v-model="value"
                                                            ref="step1"
                                                            v-if="step == 0"
                                                            :can-exit="canExit" 
                                                            :sgk-entry="sgkEntry" 
                                                            :id="id" 
                                                            :get-personal="getPersonal"
                                                            v-on:approve-statuses="$e => approveStatuses = $e || []"
                                                            :full-name="[info.FirstName,info.LastName].join(' ')"
                                                            :is-driver="isDriver"
                                                            v-on:next-step="step = 1"/>
                            <employee-hakedis-on-incleme    ref="step2"
                                                            :task-id="value.exitTaskId"
                                                            v-if="step == 1"
                                                            :id="id"
                                                            v-on:next-step="step = 2"
                                                            v-on:prev-step="step = 0"/>
                            <employee-exit-files            ref="step3"
                                                            :task-id="value.exitTaskId"
                                                            v-if="step == 2"
                                                            v-on:prev-step="step = 1"
                                                            v-on:completed="getPersonal && getPersonal()"
                                                            :id="id" />
                        </div>
                    </div>
                    <div class="row" v-else>
                        <div class="col-12">
                            <div class="alert alert-danger mb-0">
                                <div class="alert-body text-center p-1">
                                    Kullanıcının çalışma bilgisinin sistemde kaydı bulunmamaktadır.<br/>Bu kullanıcının girişi yapılmadan çıkışı yapılamaz.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="approveStatuses.length > 0" class="col-md-2">
                    <employee-exit-approve-statuses :approve-statuses="approveStatuses"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmployeeJobExitRequest from './components/EmployeeJobExitRequest.vue'
import EmployeeHakedisOnIncleme from './components/EmployeeHakedisOnIncleme.vue'
import EmployeeExitFiles from './components/EmployeeExitFiles.vue'
import VirtualSteper from '@/components/VirtualSteper.vue'
import { BSpinner } from 'bootstrap-vue'
import EmployeeExitApproveStatuses from './components/EmployeeExitApproveStatuses.vue'

export default {
    components:{
        EmployeeJobExitRequest,
        EmployeeHakedisOnIncleme,
        VirtualSteper,
        BSpinner,
        EmployeeExitFiles,
        EmployeeExitApproveStatuses
    },
    props:{
        id:[Number,String],
        isDriver:Boolean,
        value:Object,
        canExit:Boolean,
        sgkEntry:[Object,null],
        getPersonal:Function,
        info:Object
    },
    data(){
        return{
            step:0,
            approveStatuses:[],
            steps:[
                "Çıkış Detayları ve Puantaj",
                "Bordro Yükleme ve Hakediş Ön İnceleme Tablosu",
                "Çıkış Evrakları"
            ]
        }
    }
}
</script>

<style>
.bg-surface{
    background-color: white;
}

.dark-layout .bg-surface {
    background-color: #283046 !important;
}

.bg-container{
    color:inherit !important;
}
</style>